export default function initMobileDivLink() {
	const elems = document.querySelectorAll('.mobile-div-link');

	if (!elems.length || window.innerWidth > 1000) return;

	[...elems].forEach(elem => {
		const src = elem.querySelector('.mobile-div-link-source');
		if (!src) return;

		elem.addEventListener('click', () => {
			window.location = src.getAttribute('href');
		})
	});
}
